export { default } from './TemplateEdit.js';